import client from '../httpClient';

const filestorageDownloadApi = (params) => {
  return client.post('/file-storages/download', params);
};

export default filestorageDownloadApi;
